module.exports = __webpack_public_path__ + "static/img/cont211.0963e68.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont211.jpg
// module id = fM33
// module chunks = 0